import React from 'react'
import { Link } from 'react-router-dom'

const ServiceDescription = ({icon, title, description}) => {
    return (
        <div className="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up" data-aos-delay="400">
            <div className="icon flex-shrink-0"><i className={icon}></i></div>
            <div>
                <h4 className="title">
                    <Link to={`/service-details/${title}`} className="stretched-link">{title}</Link>
                </h4>
                <p className="description">{description}</p>
            </div>
        </div>
    )
}

export default ServiceDescription